export default [
  {
    text: 'Udział w międzynarodowej konferencji naukowej <a href="https://openreadings.eu/">OpenReadings</a> w Wilnie.',
    year: '2026',
  },
  {
    text: 'Członkostwo w <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> przez wakacje 2024 roku.',
    year: '2024',
  },
  { text: 'Certyfikat Acert B2 z języka angielskiego', year: '2024' },
  {
    text: 'Stypendium w ramach programu <a href="https://www.stypendia-pomostowe.pl">Stypendia pomostowe</a>.',
    year: '2023',
  },
  {
    text: 'Ponownie zdobyte stypendium w ramach programu <a href="https://www.podparpackie.edu.pl">Wsparcie stypendialne dla uczniów zdolnych<a/>',
    year: '2022',
  },
  {
    text: 'Projekt <a href="https://soulgraphy.me">Soulgraphy</a> osiągnał 100 tysięcy odsłon w internecie',
    year: '2021',
  },
  {
    text: 'Stypendium w ramach programu <a href="https://www.podparpackie.edu.pl">Wsparcie stypendialne dla uczniów zdolnych<a/>',
    year: '2020',
  },
  {
    text: 'Laureat z ogólnopolskiego konkursu „Albus” z fizyki (8. miejsce)',
    year: '2019',
  },
  { text: 'Laureat konkursu kuratoryjnego z fizyki', year: '2019' },
  {
    text: 'Podwójny laureat z ogólnopolskiego konkursu „Olimpus” z matematyki (5. miejsce) i z fizyki (9. miejsce)',
    year: '2019',
  },
]
